import React, { useEffect, useState } from 'react';
import { getApi } from '../../../api/endpoints.js';
import { useNavigate, useParams} from 'react-router-dom';
import FormPartial from './FormPartial.js';
import PageContentWrapper from "../../../components/PageContentWrapper.js";
import { toast } from 'react-toastify';
import RollOverConfig from '../../../models/RollOverConfig.js';
import Page from '../../Page.js';
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants.js';

const New = () => {
  let rollOverConfigObj = new RollOverConfig();
  const [rollOverConfig, setRollOverConfig] = useState(rollOverConfigObj.toStateJson());
  const [leaseOfferDetails, setLeaseOfferDetails] = useState({});
  const [getLeaseOfferDetailsApi] = getApi('showLeaseOffer');
  const [createApi] = getApi('createRollOverConfig');
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getLeaseOfferDetails();
  }, [])

  const getLeaseOfferDetails = async () => {
    try{
      let response = await getLeaseOfferDetailsApi({id: params.id}).unwrap();
      setLeaseOfferDetails(response.data.lease_offer);
    } catch(error) {
      toast.error(error.data?.message || 'Something went wrong !')
    }
  }

  const createRecord = async (params) => {
    try {
      let response = await createApi(params).unwrap();
      navigate(-1);
      toast.success(response.data?.message || 'Rollover Configuration Created Successfully')
    } catch (error) {
      rollOverConfigObj.set_api_errors(error.data?.data?.errors);
      setRollOverConfig(rollOverConfigObj.toStateJson());
      toast.error(error?.data?.message || "Something went wrong");
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord(new RollOverConfig(rollOverConfig).toApiJson());  
    } catch (error) {
      setRollOverConfig(new RollOverConfig(rollOverConfig));
    }
  }

  const handleCancelFunction = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewRollOverConfigPage.name)}
    breadcrumbs={[
      { label: "Home", url: '/dashboard' },
      { label: "Fleet Owners", url: `/fleet_owners` },
      { label: `${params.fleet_owner_id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Lease Offers`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `${params.id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Rollover Configurations`, url: `/fleet_owners/${params.fleet_owner_id}/lease_offers/${params.id}/rollover_configs` },
      { label: "New" }
    ]}
    className={'new-rollover-config-page'}
  >
    <PageContentWrapper contentHeading={`Generate New Rollover Configuration For Lease Offer ${leaseOfferDetails.name}`}>
      <div className='m-3'>
        <div className='mb-4 col-md-12'>
          <form className="row g-3" autoComplete="off">
            <FormPartial rollOverConfig={rollOverConfig} setRollOverConfig={setRollOverConfig} />
            <div className='mb-4 col-md-12'>
              <div >
                <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create RollOver Configuration</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PageContentWrapper>
  </Page>
}
export default New;
